import React from 'react';
import { Card } from 'semantic-ui-react';
import { DEFAULT_CHAR_LIMIT } from './Text.constants';
import ExpandableText from '../../../../../foundation/components/ExpandableText';
import './Text.css';
var defaultProps = {
  charLimit: DEFAULT_CHAR_LIMIT,
  seeMoreIcon: '',
  seeLessIcon: ''
};
export default function Text(_ref) {
  var text = _ref.text,
    charLimit = _ref.charLimit,
    seeMoreIcon = _ref.seeMoreIcon,
    seeLessIcon = _ref.seeLessIcon;
  return /*#__PURE__*/React.createElement(Card.Description, {
    className: "text"
  }, /*#__PURE__*/React.createElement(ExpandableText, {
    text: text,
    charLimit: charLimit,
    seeMoreIcon: seeMoreIcon,
    seeLessIcon: seeLessIcon
  }));
}
Text.defaultProps = defaultProps;